import { render, staticRenderFns } from "./ProjectPostingItemRestoreModal.vue?vue&type=template&id=6c0d8756"
import script from "./ProjectPostingItemRestoreModal.vue?vue&type=script&lang=js"
export * from "./ProjectPostingItemRestoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports